import React from "react";

import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import { Grid } from "@material-ui/core";
import { useField } from "formik";

import { SlimButton, SlimSecondaryButton } from "components/Button";
import { ButtonIcon } from "components/Button/FontAwesomeButton";

import { CommissionOptions, CommissionTypes } from "constants/commissions";

import { Autocomplete } from "./Autocomplete";
import { Input, PercentageInput } from "./Input";
import { Label } from "./Label";
import { withNamespace } from "./lib";

interface VendorCommissionInputProps {
  addLabel?: string;
  disabled?: boolean;
  label?: string;
  labelTooltip?: string;
  name: string;
  removeLabel?: string;
}

export const VendorCommissionInput = ({
  addLabel = "Set Vendor Commission",
  disabled = false,
  label = "",
  labelTooltip = "",
  name,
  removeLabel = "Remove",
}: VendorCommissionInputProps) => {
  const commissionTypeName = withNamespace(name, "commissionType");
  const commissionValueName = withNamespace(name, "commissionValue");
  const [{ value }, , { setValue }] = useField<Commission | null | undefined>(
    name,
  );
  const [, , { setValue: setCommissionValue }] =
    useField<string>(commissionValueName);

  return (
    <>
      {label && <Label tooltip={labelTooltip}>{label}</Label>}
      {value ? (
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12} md={5}>
            <Autocomplete
              name={commissionTypeName}
              options={CommissionOptions}
              label="Commission Type"
              getOptionValue={(option: { value: string }) => option.value}
              disableClearable
              disabled={disabled}
              onChangeExtra={() => setCommissionValue("0")}
            />
          </Grid>
          <Grid item xs={9} md={5}>
            {value.commissionType === CommissionTypes.DollarsPerHead ? (
              <Input
                label="Commission Value"
                name={commissionValueName}
                beforeSymbol="$"
                multiplier={100}
                type="number"
                decimalPlaces={3}
                decimal
                disabled={disabled}
              />
            ) : (
              <PercentageInput
                label="Commission Value"
                name={commissionValueName}
                disabled={disabled}
              />
            )}
          </Grid>
          {
            <Grid item xs={3} md={2} container justifyContent="flex-end">
              <SlimButton
                onClick={() => setValue(null)}
                backgroundColor="deleteRed"
                type="button"
                disabled={disabled}
              >
                <ButtonIcon icon={faTrash} />
                &nbsp;{removeLabel}
              </SlimButton>
            </Grid>
          }
        </Grid>
      ) : (
        <Grid item xs={12} container justifyContent="center">
          <SlimSecondaryButton
            type="button"
            onClick={() =>
              setValue({
                commissionType: CommissionTypes.Percentage,
                commissionValue: "0",
              })
            }
            data-tour="createVendorCommission"
            disabled={disabled}
          >
            {addLabel}
          </SlimSecondaryButton>
        </Grid>
      )}
    </>
  );
};
